// utilitário para gerar URL do Google Calendar a partir de um objeto genérico (tender ou evento da agenda)
// aceita formas diferentes de objeto (tender com nextActionDate/nextActionTime ou event com date/time)
export const generateGoogleCalendarUrl = (item: any): string => {
  const baseUrl = 'https://calendar.google.com/calendar/render';
  const action = 'TEMPLATE';

  // Título: usa item.title ou campos relacionados a tender
  const rawTitle = item.title || item.name || (item.titleFull && item.titleFull) || '';
  const title = rawTitle || (item.nextAction ? `${item.nextAction}: ${item.title || ''}` : 'Evento');
  const text = encodeURIComponent(title);

  // Determinar data e hora
  // Preferências por nomes diferentes usados no projeto:
  // - event: { date: 'YYYY-MM-DD', time: 'HH:MM' }
  // - tender: { nextActionDate, nextActionTime, deadline }
  const dateStr = item.date || item.nextActionDate || item.deadline || '';
  const timeStr = item.time || item.nextActionTime || '';

  const pad = (n: number) => String(n).padStart(2, '0');

  let datesParam = '';

  if (dateStr && timeStr) {
    // Criar datetimes locais (sem Z) no formato YYYYMMDDTHHMMSS
    // Construímos objetos Date para fazer cálculos corretos (ex.: rollover de dia ao somar 1h)
    // Nota: usamos o timezone local do cliente ao criar a Date a partir de `${date}T${time}:00`.
    const startDateObj = new Date(`${dateStr}T${timeStr}:00`);
    const endDateObj = new Date(startDateObj.getTime() + 60 * 60 * 1000); // +1 hora padrão

    const start = `${startDateObj.getFullYear()}${pad(startDateObj.getMonth() + 1)}${pad(startDateObj.getDate())}T${pad(startDateObj.getHours())}${pad(startDateObj.getMinutes())}${pad(startDateObj.getSeconds())}`;
    const end = `${endDateObj.getFullYear()}${pad(endDateObj.getMonth() + 1)}${pad(endDateObj.getDate())}T${pad(endDateObj.getHours())}${pad(endDateObj.getMinutes())}${pad(endDateObj.getSeconds())}`;

    datesParam = `${start}/${end}`;
  } else if (dateStr) {
    // Evento all-day: Google espera end date exclusivo — então incrementamos 1 dia para o end
    const startDateObj = new Date(`${dateStr}T00:00:00`);
    const endDateObj = new Date(startDateObj.getTime() + 24 * 60 * 60 * 1000);

    const start = `${startDateObj.getFullYear()}${pad(startDateObj.getMonth() + 1)}${pad(startDateObj.getDate())}`;
    const end = `${endDateObj.getFullYear()}${pad(endDateObj.getMonth() + 1)}${pad(endDateObj.getDate())}`;

    datesParam = `${start}/${end}`;
  }

  // Details: construir a partir de campos disponíveis (meta, organ, description, etc.)
  const detailsParts: string[] = [];
  if (item.nextAction) detailsParts.push(`Ação: ${item.nextAction}`);
  if (item.meta?.organ) detailsParts.push(`Órgão: ${item.meta.organ}`);
  if (item.organ) detailsParts.push(`Órgão: ${item.organ}`);
  if (typeof item.meta?.value === 'number') detailsParts.push(`Valor: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.meta.value)}`);
  if (typeof item.value === 'number') detailsParts.push(`Valor: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.value)}`);
  if (item.status) detailsParts.push(`Status: ${item.status}`);
  if (item.meta?.portal) detailsParts.push(`Portal: ${item.meta.portal}`);
  if (item.portal) detailsParts.push(`Portal: ${item.portal}`);
  if (item.meta?.companyId) detailsParts.push(`Empresa: ${item.meta.companyId}`);
  if (item.description) detailsParts.push(`Descrição: ${item.description}`);

  const details = encodeURIComponent(detailsParts.join('\n'));

  // Location: usar portal/state quando possível
  const locationRaw = item.meta?.portal || item.portal || item.meta?.state || item.state || '';
  const location = encodeURIComponent(locationRaw);

  // Montar query pieces (só adicionar dates/details/location se existirem)
  const params: string[] = [];
  params.push(`action=${action}`);
  params.push(`text=${text}`);
  if (datesParam) params.push(`dates=${encodeURIComponent(datesParam)}`);
  if (details) params.push(`details=${details}`);
  if (location) params.push(`location=${location}`);

  return `${baseUrl}?${params.join('&')}`;
};
